export default __webpack_public_path__ + "static/media/FHP_T_CONTEST.19cac9be.png";